module.exports = __webpack_public_path__ + "static/media/sort.8aafab9c.svg";